import React from 'react';
import PropTypes from 'prop-types';
import { Text, Flex } from '@chakra-ui/react';
import { Box } from 'components';
import { withNamespaces, Trans } from 'react-i18next';
import { observer } from 'mobx-react';

import { ChangePortalBanner } from 'apps/client/components/ChangePortalBanner';
import Heading from 'components/Heading';
import Paragraph from 'components/Paragraph';
import Icon from 'components/Icon';

import {
  LargePanelSectionWrapper,
  CollapseWrapper,
  ContentWrapper,
} from 'apps/rfq/rfqForm/views/onboarding.styled';

import { StatusDivider, Divider } from 'apps/rfq/rfqPage/views/openRFQ.styled';

import { useClientStore } from 'apps/hooks';
import { SpaceLink } from 'apps/shared';

import { StatusSwitcher, StatusDisplay } from 'apps/components/StatusSwitcher';

import IncompleteRFQSection from './incompleteRFQSection';

const RFQIntro = observer(props => {
  const clientStore = useClientStore();
  const { rfqManager, rfqApp, isIntermediator } = props;
  const {
    state,
    intermediatorSession: { shareFile },
  } = rfqApp;
  const hasIntermediatorRole = clientStore.hasRole('INTERMEDIATOR');
  const customerLink = window.location.href.replace('intermediator/', '');

  const isRFQIncomplete = state === 'INCOMPLETE';

  return (
    <LargePanelSectionWrapper first hasBanner={hasIntermediatorRole}>
      <ChangePortalBanner />
      <Text
        as='small'
        fontSize='md'
        fontWeight='bold'
        color='gray'
        mb={2}
        mt={hasIntermediatorRole ? 2 : 0}
      >
        Request for Quotation
        {hasIntermediatorRole && (
          <Text
            ml={2}
            as='span'
            fontWeight='normal'
            color='blue'
            cursor='pointer'
            _hover={{ textDecoration: 'underline' }}
            onClick={() => rfqApp.CopyLinkToClipboard(customerLink)}
          >
            Customer link{' '}
            <Icon color='#0f2eff' name='link' viewBox='0 0 32 32' />
          </Text>
        )}
      </Text>
      <Box mt={2} mb={4}>
        <Heading level='1' size='xlarge'>
          <Trans>{shareFile.name}</Trans>
        </Heading>
        {hasIntermediatorRole && (
          <SpaceLink
            variant='primary'
            label='RFQ for'
            size='medium'
            space={rfqApp.customerSpace}
          />
        )}
      </Box>
      <CollapseWrapper>
        <ContentWrapper>
          {isIntermediator ? (
            <Paragraph>
              <Trans>
                Please review the following RFQ, and either (1) assign it to one
                of our manufacturing partners for direct quoting, or (2) create
                a quote in the name of any manufacturer you&apos;ve engaged
                offline.
              </Trans>
            </Paragraph>
          ) : (
            <Paragraph>
              <Trans>
                Thank you, your RFQ has been received. One of our eningeering
                experts is evaluating your part, and will forward you quotes
                from our network within 24h.
              </Trans>
            </Paragraph>
          )}
          <>
            <StatusDivider />
            <Flex alignItems='center'>
              {isIntermediator ? (
                <StatusSwitcher
                  nextPossibleStates={rfqApp.nextPossibleStates}
                  value={state}
                  onChange={rfqManager.UpdateRFQState}
                  type='rfq'
                />
              ) : (
                <StatusDisplay status={state} type='rfq' />
              )}
            </Flex>
            {isRFQIncomplete && (
              <IncompleteRFQSection rfqManager={rfqManager} />
            )}
          </>
        </ContentWrapper>
      </CollapseWrapper>
      <Divider />
    </LargePanelSectionWrapper>
  );
});

RFQIntro.propTypes = {
  rfqApp: PropTypes.object,
  isIntermediator: PropTypes.bool,
};

export default withNamespaces()(RFQIntro);
